import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'cpPureFilter',
	pure:true
})
export class FilterPurePipe<T> implements PipeTransform {
	// compare function receives the filter val so we can make sure this pipe is used in a pure manner.
	// the parameter detectionCycleTrigger is used to trigger the pipe execution when needed
	transform(arr: T[]|any[], filterVal: T,compareFunc?:(filterVal:T,currItem:any)=>boolean, detectionCycleTrigger?:any): string[]|any[] {
		if (!filterVal || !arr) {
			return arr;
		}
		return arr.filter(currItem =>compareFunc?compareFunc(filterVal,currItem):filterVal===currItem);
	}
}
